import moment from "moment";
import { cloneDeep } from "lodash";

import types from "./types";

const initialState = {
    upgradePackagesLabels: null,
    currentPackage: null,
    currentPackageToCompare: null,
    fetchingCurrentPackage: true,
    selectedUpgrade: null,
    brokenLibraryPackages: [],
    isDirty: false,
};

const upgradeLibrary = (state = initialState, action) => {
    switch (action.type) {
        case types.SAVE_UPDATE_UPGRADE_PACKAGE_START:
            return { ...state };
        case types.SAVE_UPDATE_UPGRADE_PACKAGE_ERROR:
            return { ...state };
        case types.SAVE_UPDATE_UPGRADE_PACKAGE_SUCCESS:
            return {
                ...state,
                currentPackage: action.payload.upgradePackage,
                currentPackageToCompare: cloneDeep(action.payload.upgradePackage),
                isDirty: false,
            };
        case types.FETCH_UPGRADE_LABELS_START:
            return { ...state };
        case types.FETCH_UPGRADE_LABELS_ERROR:
            return { ...state };
        case types.FETCH_UPGRADE_LABELS_SUCCESS:
            return { ...state, upgradePackagesLabels: action.payload };
        case types.FETCH_UPGRADE_PACKAGE_START:
            return {
                ...state,
                fetchingCurrentPackage: true,
                currentPackage: null,
                currentPackageToCompare: null,
                isDirty: false,
            };
        case types.FETCH_UPGRADE_PACKAGE_ERROR:
            return {
                ...state,
                currentPackage: null,
                currentPackageToCompare: null,
                fetchingCurrentPackage: false,
                isDirty: false,
            };
        case types.FETCH_UPGRADE_PACKAGE_SUCCESS:
            return {
                ...state,
                currentPackage: action.payload,
                currentPackageToCompare: cloneDeep(action.payload),
                fetchingCurrentPackage: false,
                isDirty: false,
            };
        case types.DELETE_UPGRADE_PACKAGE_START:
            return { ...state };
        case types.DELETE_UPGRADE_PACKAGE_ERROR:
            return { ...state };
        case types.DELETE_UPGRADE_PACKAGE_SUCCESS:
            return { ...state };
        case types.CHANGE_NAME_UPGRADE_PACKAGE_START:
            return { ...state };
        case types.CHANGE_NAME_UPGRADE_PACKAGE_SUCCESS:
            return {
                ...state,
                currentPackage: action.payload,
                currentPackageToCompare: cloneDeep(action.payload),
                isDirty: false,
            };
        case types.CHANGE_NAME_UPGRADE_PACKAGE_ERROR:
            return { ...state };
        case types.DUPLICATE_UPGRADE_PACKAGE_START:
            return { ...state };
        case types.DUPLICATE_UPGRADE_PACKAGE_SUCCESS:
            return { ...state };
        case types.DUPLICATE_UPGRADE_PACKAGE_ERROR:
            return { ...state };
        case types.UPDATE_UPGRADE:
            return {
                ...state,
                isDirty: true,
                currentPackage: {
                    ...state.currentPackage,
                    lastEdited: moment().format("LLLL"),
                    upgrades: {
                        ...state.currentPackage.upgrades,
                        [action.payload.upgradeId]: action.payload.upgrade,
                    },
                },
            };
        case types.DELETE_UPGRADE: {
            const upgrades = state.currentPackage.upgrades || {};

            if (!upgrades[action.payload]) return state;

            const { [action.payload]: _, ...rest } = upgrades;

            return {
                ...state,
                isDirty: true,
                currentPackage: {
                    ...state.currentPackage,
                    upgrades: rest,
                },
            };
        }
        case types.RESET_UPGRADE_LIBRARY:
            return { ...initialState };
        case types.SELECT_UPGRADE:
            return { ...state, selectedUpgrade: action.payload };
        case types.TAG_BROKEN_PACKAGE:
            return {
                ...state,
                brokenLibraryPackages: {
                    ...state.brokenLibraryPackages,
                    [action.payload.packageId]: action.payload.packageName,
                },
            };
        default:
            return state;
    }
};

export default upgradeLibrary;
